export default __webpack_public_path__ + "static/media/hero-level-1-chars-mob.eec37536.webp";